import React, { useState } from 'react';
import Tesseract from 'tesseract.js';

const OcrTable = () => {
  const [imageData, setImageData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageData(reader.result);
        performOcr(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const performOcr = (image) => {
    setLoading(true);
    Tesseract.recognize(image, 'deu', {
      logger: (m) => console.log(m), // Progress logging
    })
      .then(({ data: { text } }) => {
        const parsedData = parseTextToTableData(text);
        setTableData(parsedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('OCR Error:', error);
        setLoading(false);
      });
  };

  const parseTextToTableData = (text) => {
    const lines = text.split('\n').filter(Boolean);
    const header = ["Beginn", "Ende", "ANR", "Menge", "Erzeugnis", "Leistung", "Laufzeit", "Zeit"];
    const data = [];

    // Customized parsing logic based on your document's structure
    lines.forEach(line => {
      const parts = line.split(/\s+/); // Split by whitespace
      if (parts.length >= 5) { // Basic check to see if it looks like a table row
        data.push({
          startTime: parts[0],
          endTime: parts[1],
          anr: parts[2],
          quantity: parts[3],
          product: parts[4],
          task: parts[5] || '',
          runTime: parts[6] || '',
          time: parts[7] || '',
        });
      }
    });

    return { header, data };
  };

  return (
    <div>
      <h1>OCR to Table (German)</h1>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      {loading && <p>Processing...</p>}
      {imageData && <img src={imageData} alt="Uploaded" style={{ maxWidth: '100%', margin: '20px 0' }} />}
      
      {tableData.data && tableData.data.length > 0 && (
        <table border="1">
          <thead>
            <tr>
              {tableData.header.map((headerItem, index) => (
                <th key={index}>{headerItem}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.data.map((row, index) => (
              <tr key={index}>
                {Object.values(row).map((cell, cellIndex) => (
                  <td key={cellIndex}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OcrTable;
